import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';

import { ProductBasicDataComponent } from './components/product-basic-data/product-basic-data.component';
import { ProductCollectionsComponent } from './components/product-collections/product-collections.component';
import { ProductImagesComponent } from './components/product-images/product-images.component';
import { ProductEditComponent } from './containers/product-edit/product-edit.component';
import { ProductsContainerComponent } from './containers/products-container/products-container.component';
import { ProductCollectionUnitsGuard } from './guards/product-collection-units.guard';
import { ProductRegistrationUserTypeStatementGuard } from './guards/product-registration-user-type-statement.guard';
import { ProductPendingComponent } from './layouts/product-pending/product-pending.component';
import { ProductPublishedComponent } from './layouts/product-published/product-published.component';
import { ProductRejectedComponent } from './layouts/product-rejected/product-rejected.component';
import { ProductsComponent } from './products.component';

const routes: Routes = [
  {
    path: '',
    component: ProductsComponent,
    children: [
      {
        path: '',
        component: ProductsContainerComponent,
        children: [
          {
            path: '',
            component: ProductPublishedComponent,
          },
          {
            path: 'pending',
            component: ProductPendingComponent,
          },
          {
            path: 'rejected',
            component: ProductRejectedComponent,
          },
        ],
      },
      {
        path: 'edit',
        component: ProductEditComponent,
        canActivate: [ProductRegistrationUserTypeStatementGuard],
        children: [
          {
            path: '',
            component: ProductBasicDataComponent,
          },
          {
            path: 'collections',
            component: ProductCollectionsComponent,
            canActivate: [ProductCollectionUnitsGuard],
          },
          {
            path: 'images',
            component: ProductImagesComponent,
            canActivate: [ProductCollectionUnitsGuard],
            canDeactivate: [CanDeactivateGuard],
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductsRoutingModule {}
